import AdminApi from './AdminApi';
export default AdminApi;